export default __webpack_public_path__ + "static/char-t-21-ko-f9d9d93f066e0c2a91879b34e2b6dcca.png";